export default "__VITE_ASSET__Cd22Z6C3__"